import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "29",
  height: "29",
  viewBox: "0 0 29 29",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "clip-rule": "evenodd",
      d: "M2.832 4.833a2 2 0 0 1 2-2h19.333a2 2 0 0 1 2 2v19.334a2 2 0 0 1-2 2H4.832a2 2 0 0 1-2-2V4.833z",
      stroke: "currentColor",
      "stroke-width": "2"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "m14.5 6.722.4-.41a.572.572 0 0 0-.798 0l.399.41zm6.615 7.778a6.732 6.732 0 0 0-.315-.992c-.261-.646-.777-1.419-1.367-2.189a38.098 38.098 0 0 0-1.97-2.335 66.819 66.819 0 0 0-2.507-2.616l-.042-.04-.01-.011-.004-.003v-.001l-.4.41-.398-.41-.001.001-.003.003-.01.01-.043.041-.157.156a66.98 66.98 0 0 0-2.35 2.46 38.074 38.074 0 0 0-1.97 2.335c-.59.77-1.106 1.543-1.367 2.189a6.794 6.794 0 0 0 6.3 9.341v-1.143a5.65 5.65 0 0 1-5.24-7.77c.2-.494.635-1.166 1.215-1.922a36.96 36.96 0 0 1 1.91-2.263A65.706 65.706 0 0 1 14.5 7.527l.363.368c.466.475 1.095 1.13 1.752 1.856a36.997 36.997 0 0 1 1.91 2.263c.579.756 1.015 1.428 1.215 1.923.074.183.139.371.194.563h1.18z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "m18.777 15.277-2.639 3.393a.067.067 0 0 0 .053.107h3.616c.056 0 .087.064.053.108l-2.639 3.392M13.49 19.769v0c-1.47-.325-2.547-1.58-2.684-3.08l-.038-.42",
      stroke: "currentColor",
      "stroke-width": "1.143",
      "stroke-linecap": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }